import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { Alert, Button } from 'react-bootstrap';
import api from '../helpers/ApiClient';
import qs from 'qs';
import ReactTooltip from 'react-tooltip'
import Loader from '../components/Loader';

class ExitIntent extends Component {

    constructor(props) {
        super(props);

        let email, subject, message, submitted, loading, questionSequence

        this.state = {
            email,
            subject,
            message,
            submitted,
            loading,
            questionSequence
        };
    }

    handleFeedback = () => {

        let { name, email, subject, message, questionSequence } = this.state;

        if(!questionSequence && message){
            this.setState({ 
                questionSequence: 1 });

            return
        }

        this.setState({ loading: true });        

        return api('/api/feedback', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: email,
                email,
                subject : 'Exit Intent',
                message
            })
        }).then(result => {

            this.setState({ loading: false,
                questionSequence: 2 });        

            if(result){
                this.setState({ 
                submitted: true });        
            }
        })
    }

    handleEmailChange = (event) => {
        this.setState({ email: event.target.value });
    }

    handleSubjectChange = (event) => {
        this.setState({ subject: event.target.value });
    }

    handleMessageChange = (event) => {
        this.setState({ message: event.target.value });
    }

//     Name
// Email Address
// Subject: (drop-down)
// - Suggestion
// - Report Bugs
// - Other
// Message

    render() {
        const { error } = this.props
        const { submitted, loading, questionSequence } = this.state;
    
        let style = {
            border:'none',
            overflow:'hidden'
           }

        return (
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div>
                            {
                                error &&
                                <Alert bsStyle="danger">
                                    <div>{error}</div>
                                </Alert>
                            }
                            {
                                !questionSequence &&
                                <div className="exit-intent-title">
                                    <h4>Opps..don't leave yet! Are you able to find the right gift or is there anything that stop you from placing an order? :)</h4>
                                </div>
                            }
                            {
                                questionSequence === 1 &&
                                <div className="exit-intent-title">
                                    <h4>Got it, mind to leave your email so that we can do something about it? :)</h4>
                                </div>
                            }
                            {
                                questionSequence === 2 &&
                                <h4>Thanks for your feedback.</h4>
                            }
                            
                            {
                                !questionSequence &&
                                <div className="form-group">    
                                    <textarea className="form-control" name="message" placeholder="Feedback" onChange={this.handleMessageChange}/>
                                </div>
                            }
                            {
                                questionSequence === 1 &&
                                <div className="form-group">    
                                    <input className="form-control" email="email" placeholder="Email Address" type="email" onChange={this.handleEmailChange}/>
                                </div>
                            }

                            <Button disabled={submitted || loading} className="btn-postcode-checker" onClick={this.handleFeedback} block>{loading? "Submitting" : submitted ? "Submitted" : "Submit"}</Button>                    
                            {
                                submitted &&
                                <div><p>Thanks for your feedback.

                                Please 'LIKE' our FB Page to get latest updates & special offer! :)
                                </p>
                                <iframe src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Fgiftrmy%2F&width=300px&layout=standard&action=like&size=small&show_faces=true&share=false&height=80&appId=514316732102457" width="300px" height="80" style={style} scrolling="no" frameBorder="0" allowTransparency="true"></iframe>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect((state, props) => {

    return {
        
    };
})(ExitIntent);